/** Single source of truth for the Videos page library AND its structured data.
 *  Add a video to a collection below and its VideoObject JSON-LD (via buildVideoJsonLd)
 *  is emitted automatically on /installation — no separate SEO step needed.
 *  Titles/descriptions/durations sourced from the owner's Vimeo entries (2026-10). */
const V = {
  "1216491366": {
    "name": "Small Form Banner Bar - How to install the Small Form Banner Bar kit for 4' wide banners",
    "description": "Small Form Banner Bar Installation The small form Banner Bar is an ideal solution for locations with limited space, including restaurants, retail stores, shopping centers, and other areas that need clear directional signage or temporary promotional messaging. In this installation video, we demonstrate how to assemble and secure the small form Banner Bar, including: Positioning and locking the T-clips Securing the aluminum Banner Bar Attaching the pole covers and pole cover caps Installing the top and side bungees Installing the bungee retainers The compact Banner Bar design keeps 4' wide banners looking professional while ensuring the message is easy to read—even in windy conditions. Learn more about Banner Bar: www.outdoorbannerframe.com",
    "duration": "PT3M52S",
    "uploadDate": "2026-08-07",
    "thumbnail": "/assets/img/covers/cover-small-form-stf.webp"
  },
  "1219643605": {
    "name": "Video 1 - How to install t-posts & pole covers",
    "description": "Get the T-post install right and the rest of the install goes fast. Video 1 of the Banner Bar Install Series walks you through the process of installing the T-posts and Banner Bar pole covers. This 5-minute walkthrough is built for sign companies and installers. Whether your installation truck rolls out for one banner or you're training new crew members, this is the baseline that keeps every Banner Bar looking clean and reading well. What this video covers: Driving T-posts straight and at the correct spacing and depth - so the Banner Bar installs straight and level. • Setting pole covers and getting the T-clip gap right - just shy of a quarter inch, the thickness of the T-clip itself, so the clip locks in instead of sliding",
    "duration": "PT5M28S",
    "uploadDate": "2026-08-19",
    "thumbnail": "/assets/img/covers/cover-two-post-p1.webp"
  },
  "1220331917": {
    "name": "Video 2 - Attach T-clips and Banner Bar",
    "description": "You're watching Video 2 of the Banner Bar Installation Series. In this short walkthrough, Ken shows how to attach the T-clips to your Banner Bar and lock everything onto the T-posts so the bar sits level and stays put. What you'll see in this video: Attaching both T-clips to the Banner Bar Sliding the bar onto one T-clip and pinning it in place (one notch is all you need at this stage) Telescoping the bar out to reach the second T-post Adding pole cover caps Using a pole cover extension to level the bar on uneven ground (about a two-inch correction in this install) Compressing grass under the T-clip so it locks beneath a nub Re-pinning and fastening both sides once everything is level One install detail worth pausing on: T-clip spacing. The gap between the bottom of your T-post nub and the top of your pole cover should be just shy of a quarter inch — about the thickness of the T-clip itself.",
    "duration": "PT2M53S",
    "uploadDate": "2026-08-21",
    "thumbnail": "/assets/img/covers/cover-two-post-p2.webp"
  },
  "1220029571": {
    "name": "Video 3 - How to Install a Six-Foot or Eight-Foot Banner on the Two-Post Banner Bar Kit",
    "description": "This video walks through the installation of a six-foot-wide banner on the two-post Banner Bar kit. You’ll see how to: Identify the top bungees by their red labels and the side bungees by their green labels Stage each bungee near its final position before attaching the banner Wrap the bungees around the banner bar and lock the hooks into place Attach the banner to the top and side corner bungees first Position the hooks consistently toward the back of the installation for best appearance Install the bungee retainers above the lower grommet bungees Achieve a flat, clean banner surface with the hardware properly positioned This installation uses the telescoping bar set to six feet. For this banner, four top bungees are used at the standard two-foot spacing, while all of the side bungees are used. The two-post Banner Bar kit includes five top bungees for an eight-foot banner and eight side bungees. Whether you’re installing a Banner Bar for a customer or setting one up on your own site, this walkthrough shows the sequence and hardware details that help produce a clean, professional installation. For more Banner Bar installation videos and product information, visit www.outdoorbannerframe.com Be sure to watch our video on how to space and install your T-posts and Banner Bar pole covers.",
    "duration": "PT3M29S",
    "uploadDate": "2026-08-20",
    "thumbnail": "/assets/img/covers/cover-two-post-p3.webp"
  },
  "1236300494": {
    "name": "Three Post Banner Bar Install - Part 1",
    "description": "Part One: Three Post Banner Bar Installation Three T-posts, two telescoping bars, zero sag. The Three Post Kit keeps wide-format banners readable and professional on highways, construction sites and large retail frontages. In this installation video, we demonstrate how to hang a 12’ or 16’ wide banner: Space t-posts using the telescoped Banner Bar(s) Start with the center post and then drive the left and right posts Level the Banner Bars using the supplied pole cover extensions Attach pole covers, t-clips, center clip bars and post caps The Three Post Banner Bar design keeps 12’ or 16’ wide banners looking professional while ensuring the message is easy to read—even in windy conditions. Learn more about the Three Post Banner Bar kit: https://outdoorbannerframe.com/products/three-post-kit",
    "duration": "PT7M48S",
    "uploadDate": "2026-10-15",
    "thumbnail": "/assets/img/covers/cover-three-post-p1.webp"
  },
  "1236720837": {
    "name": "Three Post Banner Bar Install - Part 2",
    "description": "Part Two: Three Post Banner Bar Installation Three T-posts, two telescoping bars, zero sag. The Three Post Kit keeps wide-format banners readable and professional on highways, construction sites and large retail frontages. In this installation video, we demonstrate how to hang a 12’ or 16’ wide banner: Attach TOP & SIDE bungees Hang your banner Attaching the bungee retainers The Three Post Banner Bar design keeps 12’ or 16’ wide banners looking professional while ensuring the message is easy to read—even in windy conditions. Learn more about the Three Post Banner Bar kit: https://outdoorbannerframe.com/products/three-post-kit",
    "duration": "PT5M51S",
    "uploadDate": "2026-10-16",
    "thumbnail": "/assets/img/covers/cover-three-post-p2.webp"
  },
  "1230081457": {
    "name": "How to Install a V-Config Banner Bar",
    "description": "Allows your banner to be read from both directions on a corner lot or from a primary road with two way traffic. Video 4 of the Banner Bar Install Series walks your crew through installing a V-config Banner Bar — the angled setup that lets one banner read cleanly from traffic coming two ways at once. This walkthrough is built for sign companies and installers who get asked to put banners on corner lots, building corners, or anywhere one piece needs to face traffic from two directions at once. Whether your installation truck rolls out for one V-config job or you're adding it as a standard offering for property managers and municipalities who manage corner properties year-round, this is the step-by-step that keeps every V-config install looking clean and reading well. What this video covers: V-Config layout and post location T-post installation tips Complete V-Config kit install Hang your banners . . . all under 25 minutes About the Banner Bar Install Series A short series for your team and your customers who self-install. Each video covers one phase of an install so your crew can reference exactly what they need on their next job without scrubbing through unrelated footage. Made in USA. Backed by over 25 years of experience in the commercial sign industry.",
    "duration": "PT9M28S",
    "uploadDate": "2026-09-24",
    "thumbnail": "/assets/img/covers/cover-v-config-stf.webp"
  },
  "1096726091": {
    "name": "T-Post Installation Tips",
    "description": "Learn how to easily install your T-posts when installing a Banner Bar kit. In this video you will learn: The proper depth to drive your posts How to measure post spacing using The Banner Bar instead of a tape measure How the T-clips should lock below a \"nub\" on the T-post How much T-post should extend above your pole cover and T-clip",
    "duration": "PT54S",
    "uploadDate": "2025-06-26",
    "thumbnail": "/assets/img/covers/cover-tpost-tips.webp"
  }
};

export const LIBRARY = [
  {
    id: "small-form",
    jump: "Small Form",
    heading: "Small Form Banner Bar Install",
    videos: [
      { id: "1216491366", label: "Start to finish" },
      { id: "1096726091", label: "T-Post Install Tips", playOverlay: true },
    ],
  },
  {
    id: "two-post",
    jump: "Two Post",
    heading: "Two Post Banner Bar Install",
    videos: [
      { id: "1219643605", label: "Part 1" },
      { id: "1220331917", label: "Part 2" },
      { id: "1220029571", label: "Part 3" },
      { id: "1096726091", label: "T-Post Install Tips", playOverlay: true },
    ],
  },
  {
    id: "three-post",
    jump: "Three Post",
    heading: "Three Post Banner Bar Install",
    videos: [
      { id: "1236300494", label: "Part 1" },
      { id: "1236720837", label: "Part 2" },
      { id: "1096726091", label: "T-Post Install Tips", playOverlay: true },
    ],
  },
  {
    id: "v-config",
    jump: "V-Config",
    heading: "V-Config Banner Bar Install",
    videos: [
      { id: "1230081457", label: "Start to finish" },
      { id: "1096726091", label: "T-Post Install Tips", playOverlay: true },
    ],
  },
];

const SITE = "https://outdoorbannerframe.com";

/** Resolve a library video entry to its full record (display + SEO fields). */
export function videoRecord(v) {
  const seo = V[v.id];
  return { ...v, ...seo, cover: seo.thumbnail };
}

/** One VideoObject node for a Vimeo id, or null if the id isn't in the library. */
export function videoNode(id, pageUrl = `${SITE}/installation`) {
  const seo = V[String(id)];
  if (!seo) return null;
  return {
    "@type": "VideoObject",
    name: seo.name,
    description: seo.description,
    thumbnailUrl: `${SITE}${seo.thumbnail}`,
    uploadDate: seo.uploadDate,
    duration: seo.duration,
    embedUrl: `https://player.vimeo.com/video/${id}`,
    url: pageUrl,
  };
}

/** VideoObject JSON-LD (@graph, one node per UNIQUE Vimeo id) for the /installation route. */
export function buildVideoJsonLd() {
  const seen = new Set();
  const nodes = [];
  for (const sec of LIBRARY) {
    for (const v of sec.videos) {
      if (seen.has(v.id)) continue;
      seen.add(v.id);
      nodes.push(videoNode(v.id));
    }
  }
  return { "@context": "https://schema.org", "@graph": nodes };
}
